import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainLayout from "./mainLayout";

function Main() {
  const { t } = useTranslation();

  return (
    <>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </>
  );
}

export default Main;
